const { $Q, $Qll } = require("graditify-utils");

export function checkCollectorTerms() {
  const CTA = $Q("#AddToCart");
  const isCollector = CTA.dataset.collector;
  if (isCollector === "true") {
    const termsCheckbox = $Q("#terms-cta input");
    if (!termsCheckbox.checked) CTA.disabled = true;
    termsCheckbox.addEventListener("click", () => {
      if (!termsCheckbox.checked) CTA.disabled = true;
      if (termsCheckbox.checked) CTA.disabled = false;
    });
  }
}

export function splitCollectorPoints() {
  const points = $Qll(".collector-points");

  points.forEach((point) => {
    let pointFormated = Number(point.innerText).toLocaleString("de-DE");
    pointFormated = pointFormated.replace(".", " ");
    point.innerText = pointFormated;
  });
}
